
// TODO: When better solution for nationalities occurs, modify the list
import countriesList from '@/resources/countriesList';
import CountryFlag from 'vue-country-flag';

export default {
  name: 'NationalityInput',

  components: {
    CountryFlag,
  },

  model: {
    prop: 'nationality',
    event: 'input',
  },

  props: {
    disabled: {
      type: Boolean,
      default: false,
    },

    mandatory: {
      type: Boolean,
      default: true,
    },
  },

  data(): Record<string, unknown> {
    return {
      countriesList,
      nationality: '',
      uniqueSeleniumClass: `selenium--nationality-input-${new Date().getTime()}`,
    };
  },

  computed: {
    nationalityAttr(): string {
      return this.$attrs.nationality;
    },
  },

  watch: {
    nationalityAttr(): void {
      this.nationality = this.nationalityAttr;
    },

    nationality(): void {
      this.prependFlag();
    },

    disabled(): void {
      this.prependFlag();
    },
  },

  methods: {
    prependFlag(): void {
      const thisInput: HTMLElement | null = document.querySelector(`.${this.uniqueSeleniumClass}`);
      const thisInputInner: HTMLInputElement = thisInput?.querySelector('.el-input__inner');

      if (thisInputInner) {
        thisInputInner.style.paddingLeft = this.disabled ? '0' : this.determinePadding();
      }
    },

    determinePadding(): string {
      return this.nationality ? '1.5rem' : '0';
    },
  },
};
